import { render, staticRenderFns } from "./PrerenderingItems.vue?vue&type=template&id=01a48d71&"
import script from "./PrerenderingItems.vue?vue&type=script&lang=js&"
export * from "./PrerenderingItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports